<template>
  <div>
    <el-button type="primary" @click="handleAdd">新增</el-button>

    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column type="index" label="序号" width="80"></el-table-column>
      <el-table-column prop="batch" label="批次" width="200"></el-table-column>
      <el-table-column prop="price" label="单价"width="200"></el-table-column>
      <el-table-column prop="num" label="数量"width="200"></el-table-column>
      <el-table-column prop="description" label="备注"width="500"></el-table-column>
    </el-table>

    <!-- 新增对话框 -->
    <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        append-to-body
        destroy-on-close
        width="30%"
    >
      <el-form :model="form" label-width="80px">
        <el-form-item label="批次">
          <el-input v-model="form.batch"></el-input>
        </el-form-item>
        <el-form-item label="单价">
          <el-input v-model="form.price"></el-input>
        </el-form-item>
        <el-form-item label="数量">
          <el-input v-model="form.num"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.description"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import requestTicket from '@/utils/requestTicket';

export default {
  props: {
    id: {
      type: Number
    }
  },
  data() {
    return {
      tableData: [],
      // 添加分页参数
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      bomDialogVisible: false,
      dialogTitle: '',
      currentMaterialId: null,
      form: {
        id: null,
        batch: '',
        price: '',
        num: '',
        description: ''
      },
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    // 查询数据
    async fetchData() {
      try {
        const response = await requestTicket.post('/Ticketing/procedure/execute', {
          procedureName: "get_material_item_with_num",
          parameters: [this.id]
        });
        this.tableData = response.data;
        this.total = response.data.total; // 假设返回总记录数在totalElements字段
      } catch (error) {
        console.error('获取数据失败:', error);
      }
    },

    // 添加分页事件处理方法
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },

    // 新增功能
    handleAdd() {
      this.dialogTitle = '新增物料项';
      this.form = {
        id: null,
        batch: '',
        price: '',
        num: '',
        description: ''
      };
      this.dialogVisible = true;
    },

    // 保存数据
    async save() {
      try {
        await requestTicket.post('/Ticketing/material-item/save', this.form);
        this.$message.success('保存成功');
        this.dialogVisible = false;
        this.fetchData(); // 重新加载数据
      } catch (error) {
        this.$message.error('保存失败: ' + error.message);
      }
    }
  }
};
</script>

<style scoped>
.el-button {
  margin-bottom: 15px;
  margin-right: 10px;
}
</style>